<template>
    <div>
        <v-container class="my-2">
            <v-layout row wrap px-0 mb-4>
                <v-flex xs9>
                    <v-breadcrumbs class="px-0" :items="$store.getters.language.data.site_forms.list_path">
                        <template v-slot:item="{ item }">
                            <v-breadcrumbs-item :to="item.path" :disabled="item.disabled">
                                {{ item.title.toUpperCase() }}
                            </v-breadcrumbs-item>
                        </template>
                    </v-breadcrumbs>
                </v-flex>
                <v-flex xs3>

                </v-flex>
            </v-layout>
            <form @submit.prevent="addSiteForms" autocomplete="off">
                <v-layout row wrap>

                    <v-flex xs12 lg12 xl12 md3 sm4>
                        <v-text-field v-model="site_forms.site_form_url" type="textarea" :label="$store.getters.language.data.site_forms.site_form_url" dense
                            class="mx-1"  filled outlined >
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 lg4 xl4 md4 sm4>
                        <v-text-field v-model="site_forms.site_form_text_ku" type="textarea"
                            :label="$store.getters.language.data.site_forms.site_form_text_ku" dense class="mx-1" filled
                            outlined required>
                        </v-text-field>
                    </v-flex>

                    <v-flex xs12 lg4 xl4 md4 sm4>
                        <v-text-field v-model="site_forms.site_form_text_en" type="textarea"
                            :label="$store.getters.language.data.site_forms.site_form_text_en" dense class="mx-1" filled
                            outlined required>
                        </v-text-field>
                    </v-flex>

                    <v-flex xs12 lg4 xl4 md4 sm4>
                        <v-text-field v-model="site_forms.site_form_text_ar" type="textarea"
                            :label="$store.getters.language.data.site_forms.site_form_text_ar" dense class="mx-1" filled
                            outlined required>
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 >
                        <v-textarea rows="3" auto-grow v-model="site_forms.site_from_embed_code" type="textarea" :label="$store.getters.language.data.site_forms.site_from_embed_code" dense
                            class="mx-1"  filled outlined >
                        </v-textarea>
                    </v-flex>
                    <v-flex xs12 lg2 xl2 md2 sm4>
                        <v-btn color="primary" class="mx-1" :loading="loading_btn" type="submit">
                            {{$store.getters.language.data.site_forms.add_btn}}</v-btn>
                    </v-flex>
                </v-layout>
            </form>
            <v-layout row wrap mt-5>
                <v-flex xs12>
                    <v-card flat>
                        <v-card-text>
                            <v-data-table :loading="loading" :headers="headers" :search="search" :items="rows"
                                class="elevation-0" item-key="site_form_id">
                                <template v-slot:[`item.site_form_id`]="{ item }">
                                    <div>
                                        <v-btn icon :to="'/site_forms-list/'+item.site_form_id" color="teal"
                                            class="mx-1">
                                            <v-icon> mdi-pencil-outline </v-icon>
                                        </v-btn>
                                        <v-menu offset-y>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn color="error" icon class="mx-1" v-bind="attrs" v-on="on">
                                                    <v-icon> mdi-delete-outline </v-icon>
                                                </v-btn>
                                            </template>
                                            <v-card>
                                                <v-card-text>
                                                    {{$store.getters.language.data.site_forms.delete_question}}
                                                </v-card-text>
                                                <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-btn text class="elevation-0">
                                                        {{$store.getters.language.data.site_forms.cancel_btn}}
                                                    </v-btn>
                                                    <v-btn color="error" class="elevation-0"
                                                        @click="deleteSiteForms(item.site_form_id)">
                                                        {{$store.getters.language.data.site_forms.yes_btn}}
                                                    </v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-menu>
                                    </div>
                                </template>
                            </v-data-table>
                        </v-card-text>

                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>

        <v-snackbar v-model="snackbar.value" :color="snackbar.color">
            {{snackbar.text}}
        </v-snackbar>
    </div>
</template>
<script>
    import requests from './../../requests/site_forms.request.js'
    import * as xlsx from 'xlsx/xlsx.js';
    export default {
        data() {
            return {
                site_forms: {},
                search: '',
                loading: true,
                loading_btn: false,

                snackbar: {
                    value: false,
                    text: '',
                    color: ''
                },
                rows: [],

                selected_site_forms: {},
                headers: [


                    {
                        text: this.$store.getters.language.data.site_forms.site_form_url,
                        align: 'start',
                        sortable: true,
                        value: 'site_form_url',
                    },
                    
                    {
                        text: this.$store.getters.language.data.site_forms.site_form_text_en,
                        align: 'start',
                        sortable: true,
                        value: 'site_form_text_en',
                    },
                    {
                        text: this.$store.getters.language.data.actions,
                        align: 'start',
                        sortable: true,
                        value: 'site_form_id',
                    }
                ],
            }
        },
        computed: {
            page() {
                const pageKey = 'SITEFORMS'
                return {}
            }
        },
        mounted() {
            this.readSiteForms();
        },
        methods: {
            exportExcel() {
                const list = this.rows
                let result = []
                for (let i = 0; i < list.length; i++) {
                    const item = list[i];
                    let obj = {
                        site_form_id: item.site_form_id,
                        site_form_url: item.site_form_url,
                        site_form_text_ku: item.site_form_text_ku,
                        site_form_text_en: item.site_form_text_en,
                        site_form_text_ar: item.site_form_text_ar,
                        site_form_from: item.site_form_from,
                        site_form_to: item.site_form_to,
                        site_form_date: item.site_form_date,
                        site_form_cover: item.site_form_cover,
                        site_from_embed_code: item.site_from_embed_code,
                    }
                    result.push(obj)
                }
                var f = xlsx.utils.json_to_sheet(result)
                var wb = xlsx.utils.book_new()
                xlsx.utils.book_append_sheet(wb, f, 'sheet')
                xlsx.writeFile(wb, result.length + ' rows of ' + 'SiteForms.xlsx')
            },
            addSiteForms() {
                this.loading_btn = true
                requests.createSiteForms(this.site_forms).then(r => {
                        if (r.status == 200) {
                            this.site_forms = {}
                            this.rows.push(
                                r.data.new_data
                            )
                            this.snackbar = {
                                value: true,
                                text: 'SiteForms Added',
                                color: 'success'
                            }
                        } else {
                            this.snackbar = {
                                value: true,
                                text: 'Fail to add SiteForms',
                                color: 'error'
                            }
                        }
                    })
                    .finally(() => {
                        this.loading_btn = false
                    })

            },
            deleteSiteForms(site_form_id) {
                requests.deleteSiteForms(site_form_id).then(r => {
                    if (r.status == 200) {
                        this.rows = this.rows.filter(f => {
                            return f.site_form_id != site_form_id
                        })
                        this.snackbar = {
                            value: true,
                            text: 'SiteForms Deleted',
                            color: 'success'
                        }
                    } else {
                        this.snackbar = {
                            value: true,
                            text: 'Delete Faild',
                            color: 'error'
                        }
                    }
                })
            },

            readSiteForms() {
                this.loading = true
                requests.getAllSiteForms().then(r => {
                        if (r.status == 200) {
                            this.rows = r.data.site_forms

                            this.loading = false
                        } else {
                            this.snackbar = {
                                value: true,
                                text: 'Fail to read SiteForms',
                                color: 'error'
                            }
                        }
                    })
                    .catch(e => {
                        this.snackbar = {
                            value: true,
                            text: 'Fail to read SiteForms',
                            color: 'error'
                        }
                    })
                    .finally(() => {
                        this.loading = false
                    })
            },
            selectSiteForms(i) {
                this.selected_site_forms = i
                this.delete_dialog = true
            },
        },
    }
</script>